import { requestApi } from "./axios";
const prefix = 'auth';

export function loginApi({ username, password }) {
    return requestApi(`${prefix}/login`, 'POST', { username, password });
}